"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _reactStripeElements = require("react-stripe-elements");

var _semanticUiReact = require("semantic-ui-react");

var _axios = _interopRequireDefault(require("axios"));

var _subscriptionPlans = _interopRequireDefault(require("../data/subscription-plans"));

var _paymentTypes = _interopRequireDefault(require("../data/payment-types"));

var CheckoutForm =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CheckoutForm, _React$Component);

  function CheckoutForm(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckoutForm);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CheckoutForm).call(this, props));
    _this.state = {
      firstName: null,
      lastName: null,
      address: null,
      city: null,
      state: null,
      zipCode: null,
      email: props.email || null,
      phoneNumber: null,
      submitEnabled: false,
      checkoutLoading: false,
      showErrorMessage: false
    };
    _this.onSubmit = _this.onSubmit.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFirstNameChanged = _this.onFirstNameChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onLastNameChanged = _this.onLastNameChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onAddressChanged = _this.onAddressChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCityChanged = _this.onCityChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStateChanged = _this.onStateChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onZipCodeChanged = _this.onZipCodeChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onEmailChanged = _this.onEmailChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onPhoneNumberChanged = _this.onPhoneNumberChanged.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onLoadCompleted = _this.onLoadCompleted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkInputs = _this.checkInputs.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onCheckoutError = _this.onCheckoutError.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(CheckoutForm, [{
    key: "onFirstNameChanged",
    value: function onFirstNameChanged(e, _ref) {
      var _this2 = this;

      var value = _ref.value;
      this.setState({
        firstName: value
      }, function () {
        _this2.checkInputs();
      });
    }
  }, {
    key: "onLastNameChanged",
    value: function onLastNameChanged(e, _ref2) {
      var _this3 = this;

      var value = _ref2.value;
      this.setState({
        lastName: value
      }, function () {
        _this3.checkInputs();
      });
    }
  }, {
    key: "onAddressChanged",
    value: function onAddressChanged(e, _ref3) {
      var _this4 = this;

      var value = _ref3.value;
      this.setState({
        address: value
      }, function () {
        _this4.checkInputs();
      });
    }
  }, {
    key: "onCityChanged",
    value: function onCityChanged(e, _ref4) {
      var _this5 = this;

      var value = _ref4.value;
      this.setState({
        city: value
      }, function () {
        _this5.checkInputs();
      });
    }
  }, {
    key: "onStateChanged",
    value: function onStateChanged(e, _ref5) {
      var _this6 = this;

      var value = _ref5.value;
      this.setState({
        state: value
      }, function () {
        _this6.checkInputs();
      });
    }
  }, {
    key: "onZipCodeChanged",
    value: function onZipCodeChanged(e, _ref6) {
      var _this7 = this;

      var value = _ref6.value;
      this.setState({
        zipCode: value
      }, function () {
        _this7.checkInputs();
      });
    }
  }, {
    key: "onEmailChanged",
    value: function onEmailChanged(e, _ref7) {
      var _this8 = this;

      var value = _ref7.value;
      this.setState({
        email: value
      }, function () {
        _this8.checkInputs();
      });
    }
  }, {
    key: "onPhoneNumberChanged",
    value: function onPhoneNumberChanged(e, _ref8) {
      var _this9 = this;

      var value = _ref8.value;
      this.setState({
        phoneNumber: value
      }, function () {
        _this9.checkInputs();
      });
    }
  }, {
    key: "onLoadCompleted",
    value: function onLoadCompleted() {
      this.setState({
        checkoutLoading: false
      });
    }
  }, {
    key: "onCheckoutError",
    value: function onCheckoutError() {
      this.setState({
        showErrorMessage: true
      });
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var _this10 = this;

        var _this$props, business, currentPlanIndex, isAnnual, stripe, onCheckoutCompleted, _this$state, firstName, lastName, address, city, state, zipCode, email, phoneNumber, planIndex, _ref9, token, url, headers, data;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({
                  checkoutLoading: true
                });
                _this$props = this.props, business = _this$props.business, currentPlanIndex = _this$props.currentPlanIndex, isAnnual = _this$props.isAnnual, stripe = _this$props.stripe, onCheckoutCompleted = _this$props.onCheckoutCompleted;
                _this$state = this.state, firstName = _this$state.firstName, lastName = _this$state.lastName, address = _this$state.address, city = _this$state.city, state = _this$state.state, zipCode = _this$state.zipCode, email = _this$state.email, phoneNumber = _this$state.phoneNumber;
                planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
                _context.next = 6;
                return stripe.createToken({
                  name: "".concat(firstName, " ").concat(lastName)
                });

              case 6:
                _ref9 = _context.sent;
                token = _ref9.token;
                url = process.env.SERVER_URL;
                headers = {
                  'x-api-key': process.env.X_API_KEY
                };
                data = {
                  stripe_token: token.id,
                  stripe_subscription_plan: _subscriptionPlans["default"][planIndex].id,
                  customer: {
                    firstName: firstName,
                    lastName: lastName,
                    address: address,
                    city: city,
                    state: state,
                    zipCode: zipCode,
                    email: email,
                    phoneNumber: phoneNumber
                  }
                };

                _axios["default"].post("".concat(url, "businesses/").concat(business.type, "s/").concat(business.id, "/subscriptions/"), data, {
                  headers: headers
                }).then(function () {
                  _this10.onLoadCompleted();

                  onCheckoutCompleted();
                })["catch"](function (err) {
                  _this10.onLoadCompleted();

                  if (err) {
                    _this10.onCheckoutError();
                  }
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }, {
    key: "checkInputs",
    value: function checkInputs() {
      var _this$state2 = this.state,
          firstName = _this$state2.firstName,
          lastName = _this$state2.lastName,
          address = _this$state2.address,
          city = _this$state2.city,
          state = _this$state2.state,
          zipCode = _this$state2.zipCode,
          email = _this$state2.email,
          phoneNumber = _this$state2.phoneNumber;

      if (firstName && lastName && address && city && state && zipCode && email && phoneNumber) {
        this.setState({
          submitEnabled: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          currentPlanIndex = _this$props2.currentPlanIndex,
          isAnnual = _this$props2.isAnnual,
          currentDomain = _this$props2.currentDomain;
      var _this$state3 = this.state,
          submitEnabled = _this$state3.submitEnabled,
          checkoutLoading = _this$state3.checkoutLoading,
          showErrorMessage = _this$state3.showErrorMessage,
          firstName = _this$state3.firstName,
          lastName = _this$state3.lastName,
          address = _this$state3.address,
          city = _this$state3.city,
          state = _this$state3.state,
          zipCode = _this$state3.zipCode,
          email = _this$state3.email,
          phoneNumber = _this$state3.phoneNumber;
      var paymentPlan = _paymentTypes["default"][currentPlanIndex];
      var totalIfNotAdvanced = isAnnual ? paymentPlan.monthly.price * 12 : paymentPlan.monthly.price;
      var baseTotal = currentPlanIndex < 2 ? totalIfNotAdvanced : null;
      var discount = isAnnual ? paymentPlan.monthly.price * 2 : 0;
      var total = baseTotal - discount;
      var planIndex = isAnnual ? currentPlanIndex * 2 : currentPlanIndex * 2 + 1;
      var plan = _subscriptionPlans["default"][planIndex];
      var planDisplayName = plan.name.split(' - ')[0] + (isAnnual ? ' x 12 months' : ' x 1 month');
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_semanticUiReact.Modal.Header, {
        className: "modal-header"
      }, "Checkout"), _react["default"].createElement("div", {
        className: "checkout checkout-body"
      }, _react["default"].createElement("div", {
        className: "checkout-border checkout-payment-details"
      }, _react["default"].createElement(_semanticUiReact.Grid, null, _react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "checkout-payment-heading-row"
      }, _react["default"].createElement("h3", {
        className: "header-text blue-color"
      }, "Payment Details")), _react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), _react["default"].createElement(_semanticUiReact.Grid.Row, null, _react["default"].createElement("p", {
        className: "checkout-subheader body-text blue-color"
      }, "Billing Information"), _react["default"].createElement(_reactStripeElements.CardElement, {
        className: "stripe-checkout-input"
      })), _react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), _react["default"].createElement(_semanticUiReact.Grid.Row, null, _react["default"].createElement("p", {
        className: "checkout-subheader body-text blue-color"
      }, "Billing Address"), _react["default"].createElement(_semanticUiReact.Input, {
        value: firstName,
        id: "first-name-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "First Name",
        onChange: this.onFirstNameChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        value: lastName,
        id: "last-name-input",
        className: "checkout-input check-input-half",
        placeholder: "Last Name",
        onChange: this.onLastNameChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        value: address,
        id: "address-input",
        className: "checkout-input",
        placeholder: "Address",
        onChange: this.onAddressChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        value: city,
        id: "city-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "City",
        onChange: this.onCityChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        calue: state,
        id: "state-input",
        className: "checkout-input checkout-input-quarter checkout-input-quarter-first",
        placeholder: "State",
        onChange: this.onStateChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        value: zipCode,
        id: "zip-code-input",
        className: "checkout-input checkout-input-quarter",
        placeholder: "Zip Code",
        onChange: this.onZipCodeChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        value: email,
        id: "email-input",
        className: "checkout-input check-input-half check-input-half-first",
        placeholder: "Email",
        onChange: this.onEmailChanged
      }), _react["default"].createElement(_semanticUiReact.Input, {
        value: phoneNumber,
        id: "phone-number-input",
        className: "checkout-input check-input-half",
        placeholder: "Phone Number",
        onChange: this.onPhoneNumberChanged
      })))), _react["default"].createElement("div", {
        className: "checkout-order-summary checkout-border"
      }, _react["default"].createElement(_semanticUiReact.Grid, null, _react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "checkout-payment-heading-row"
      }, _react["default"].createElement("h3", {
        className: "header-text blue-color"
      }, "Order Summary"), _react["default"].createElement("p", null, "Once you place the order, we\u2019ll connect your website to your selected domain and notify you when the site is live. We\u2019ll also call you to walk through how to make site edits directly.")), _react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), _react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "body-text blue-color checkout-row"
      }, _react["default"].createElement("p", {
        className: "checkout-row-left"
      }, planDisplayName), _react["default"].createElement("p", {
        className: "checkout-row-right"
      }, "$", baseTotal)), discount !== 0 && _react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "green-color checkout-row"
      }, _react["default"].createElement("p", {
        className: "checkout-row-left"
      }, "Annual plan savings"), _react["default"].createElement("p", {
        className: "checkout-row-right"
      }, "-$", discount)), _react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "checkout-row"
      }, _react["default"].createElement("p", {
        className: "checkout-row-left"
      }, "Domain Service"), _react["default"].createElement("p", {
        className: "checkout-row-right strike-through-text"
      }, "$15")), _react["default"].createElement("div", {
        className: "checkout-row checkout-domain-description"
      }, _react["default"].createElement("p", {
        className: "checkout-row-left"
      }, currentDomain), _react["default"].createElement("p", {
        className: "checkout-row-right green-color"
      }, "FREE")), _react["default"].createElement(_semanticUiReact.Divider, {
        className: "checkout-divider"
      }), _react["default"].createElement(_semanticUiReact.Grid.Row, {
        className: "blue-color checkout-row"
      }, _react["default"].createElement("p", {
        className: "checkout-row-left bolded"
      }, "Total"), _react["default"].createElement("p", {
        className: "checkout-row-right bolded"
      }, "$", total)), _react["default"].createElement(_semanticUiReact.Grid.Row, null, submitEnabled ? _react["default"].createElement(_semanticUiReact.Button, {
        className: "centered-button checkout-button-enabled",
        onClick: this.onSubmit,
        loading: checkoutLoading
      }, "Place Order") : _react["default"].createElement(_semanticUiReact.Button, {
        className: "centered-button checkout-button-disabled"
      }, "Place Order")), showErrorMessage && _react["default"].createElement("p", {
        className: "error-message centered-content"
      }, "Error in Processing Payment")))));
    }
  }]);
  return CheckoutForm;
}(_react["default"].Component);

var _default = (0, _reactStripeElements.injectStripe)(CheckoutForm);

exports["default"] = _default;